import { render, staticRenderFns } from "./PrintMedicalHistory.vue?vue&type=template&id=7ad45ffc&scoped=true"
import script from "./PrintMedicalHistory.vue?vue&type=script&lang=js"
export * from "./PrintMedicalHistory.vue?vue&type=script&lang=js"
import style0 from "./PrintMedicalHistory.vue?vue&type=style&index=0&id=7ad45ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad45ffc",
  null
  
)

export default component.exports